import { useIntl } from "react-intl";

import { SubmitButton } from "../common/submit-button";

export const ExistingSitesSubmitButton = () => {
    const intl = useIntl();

    // submitting for translations
    //@ts-ignore
    const newSubmitMessage = intl.formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    });

    const submitMessage = intl.formatMessage({
        id: "BxpUiSignup.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    });

    return <SubmitButton submitMessage={submitMessage} />;
};
